var base = require('base/product/base');
const { error } = require('jquery');
var modalMessage = require('./modalMessage.js');
var hash = require('../js/to-top.js');

var vsStoreName = $('input#vs-store-name').val();
var vsEnv = $('input#vs-environment').val();
var vsDeviceType = $('input#vs-device-type').val();

(function(d) {
    var s = d.createElement("script"); 
    s.type = "text/javascript"; 
    s.charset = "utf-8";
    s.async = true;
    s.src = ("https:" == d.location.protocol ? "https://" : "http://") + "integration.virtusize.com/" + vsEnv + "/" + vsStoreName + "/" + vsDeviceType + ".source.js";
    var s1 = d.getElementsByTagName("script")[0]; s1.parentNode.insertBefore(s, s1);
})(document);

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    var timer = null;
    $('.minicart').trigger('count:update', response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('modal_error__text').text('');
        }

        $(".cart_done").fadeIn();
        $(".cart_done").addClass('active');
        $('.cart_modal').fadeOut();
        $('.cart_modal').removeClass('is-active');
        $('.main-content').removeClass('fixed');
        $('.cart_modal_bg').fadeOut('slow', function () {
            $('.cart_modal_bg').remove();
        });
        $('body').removeClass('is-open');
        if(timer) {clearTimeout(timer)}
        timer = setTimeout(function(){
            $('.cart_done, .cart_done_wishlist, .cart_done_wishlist_all').fadeOut('slow', function(){
                $(".cart_done, .cart_done_wishlist, .cart_done_wishlist_all").removeClass('active');
            })
        }, 3000);
    }
}

/**
 * @function
 * @name prepareDataGAAddToCart
 * @description Prepare datalayer for the GA4 cart event and add to dataLayer global properties to send data to GTM
 * @param {Object} data - Ajax response from clicking the add to cart button
 */
function prepareDataGAAddToCart(data) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    if('cartGADataLayer' in data.cart) {
        var cartDataLayer = data.cart.cartGADataLayer;
        var members_id = cartDataLayer.user_id ? cartDataLayer.user_id : '';
        if (cartDataLayer.user_id) {
            cartDataLayer.user_id = CryptoJS.SHA256(cartDataLayer.user_id).toString(CryptoJS.enc.Hex);
        }
        //add_to_cart ga4 event datalayer
        dataLayer.push({
            event: cartDataLayer.event,
            user_id: cartDataLayer.user_id,
            members_id: members_id,
            ecommerce: cartDataLayer.ecommerce
        });
    }
    var personalDataTopPage = $('input[name="personalData"]').val();
    if (personalDataTopPage) {
        personalDataTopPage = JSON.parse(personalDataTopPage);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'personaldata',
            members_id: personalDataTopPage.members_id,
            email: personalDataTopPage.email || '',
            phone: personalDataTopPage.phone || '',
            zipcode: personalDataTopPage.zipcode || ''
        });
    }
}

module.exports = {
    recommend: function () {
        $('body').on('click', '.recommend-block__icon', function () {
            $(this).addClass("recommend_yes");
        });
    },
    addToCart: function () {
        $(document).on('click', 'button.cart_item_detail_a', function () {
            $('#modal_error').remove();
            var _this = this;
            var addToCartUrl;
            imageClose = $(this).data("imageurl");
            pid = $(this).data("pid");
            var uuid= $(this).data("uuid");
            addToCartUrl = $(this).data("addtotarturl");
            var merchant_id = $('#maincontent').data('merchant-id');

            $('body').trigger('product:beforeAddToCart', this);

            var form = {
                pid: pid,
                pidsObj: null,
                quantity: 1,
            };
        

            if (addToCartUrl) {
                $(this).prop('disabled', true);
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        if (data.error === true) {
                            $.spinner().stop();
                            $('.bg_cart').fadeOut('slow', function () {
                                $('.bg_cart').remove();
                                $('body').removeClass('lock_scroll');
                            });
                            modalMessage.displayModalMessage(data.message,imageClose);
                        } else {
                            staffStart.cart.sendTrackingRequest(merchant_id, { product_code: form.pid, count: form.quantity });
                            handlePostCartAdd(data);
                            $(".cart_done_wishlist.uuid-"+uuid).fadeIn();
                            $('.cart_done_wishlist.uuid-'+uuid).addClass('active');
                            $(".header__cart-number.cart-number.quantity-total").text(parseInt(data.cart.numItems));
                            if (parseInt(data.cart.numItems) > 0) {
                                $('.header__cart-number.cart-number.quantity-total').removeClass('d-none');
                            } else {
                                $('.header__cart-number.cart-number.quantity-total').addClass('d-none');
                            }
                            $("body").trigger("product:afterAddToCart", data);
                            $.spinner().stop();
                            setTimeout(function () {
                                $('body').removeClass('lock_scroll');
                            },500);
                            base.miniCartReportingUrl(data.reportingURL);
                        
                            // Send data to GSS
                            let item = data.cart.items.find(({ id }) => id === form.pid.toString());

                            if (item) {
                                prepareDataGAAddToCart(data);
                                let { sales, list } = item.price;
                                let price = sales ? sales.value : list.value;
                                price = Math.floor(price * 1.1);
                                let dataLayerGSSA = {
                                    action: 'cart',
                                    item: `${item.productUPC},${form.quantity},${price}`,
                                    amount: price * form.quantity,
                                };

                                setGSSADefault();
                                Object.entries(dataLayerGSSA).forEach(([key, value]) => GSSA.set(key, value));
                                GSSA.send();
                            }
                        }
                        $(_this).prop('disabled', false);
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
            $('html').css('overflow', 'initial').css('margin-right', '0').css('touch-action', '');
        });
    },
    removeAllWishlist : function(){
        $('body').on('click', 'button.remove-all-wishlist', function(){
            var url;
            url = $(this).data("removeallurl")
            var el=`<div class="col-12 text-center"><p>お気に入りが登録されていません。</p></div>`
            if (url) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: 'html',
                    data: {},
                    success: function (data) {
                        $('.wish_block').html(el);
                        $('.wish_block').css('display', 'block')
                        $('.button-box').empty();
                        $('.wishlist-none').empty();
                        $('.wish-btn-container').removeClass('just-space');
                        $('.header__cart-number.cart-number.wishlist_total').text(parseInt(0));
                        $('body, html').animate({
                            scrollTop: 0
                        }, 300);
                    },
                    error: function () {
                    },
                });
            }
        })
    },

    addAllToCart: function(){
        $('body').on('click', 'button.add-all-to-cart', function(){
            $('#modal_error').remove();
            var url;
            url = $(this).data("addalltocart")
            imageClose = $(this).data("imageurl");
            if (url) {
                $(this).prop('disabled', true);
                var $this = $(this);
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: "GET",
                    data: {},
                    success: function (data) {
                        handlePostCartAdd(data);
                        if(data.error && data.case === 'GEO_RESTRICTION'){
                            $.spinner().stop();
                            $('.bg_cart').fadeOut('slow', function () {
                                $('.bg_cart').remove();
                                $('body').removeClass('lock_scroll');
                            });
                            modalMessage.displayModalMessage(data.message, imageClose);
                            $this.prop('disabled', false);
                            return;
                        }
                        if (!data.error) {
                            $('.cart_done_wishlist_all').fadeIn();
                            $('.cart_done_wishlist_all').addClass('active');
                            prepareDataGAAddToCart(data);
                        }
                        $(".header__cart-number.cart-number.quantity-total").text(parseInt(data.cart.numItems));
                        if (parseInt(data.cart.numItems) > 0) {
                            $('.header__cart-number.cart-number.quantity-total').removeClass('d-none');
                        } else {
                            $('.header__cart-number.cart-number.quantity-total').addClass('d-none');
                        }
                        $("body").trigger("product:afterAddToCart", data);
                        $.spinner().stop(); 
                        if(data.error === true){
                            modalMessage.displayModalMessage(data.message, imageClose);
                        }
                        $('button.add-all-to-cart').prop('disabled', false);
                    },
                    error: function () {
                        $('button.add-all-to-cart').prop('disabled', false);
                    },
                });
            }
        });
    },
    getInventory: function () {
        $(document).on('click', '.side__submit.js-cart_modal_btn, .card__icon', function (e) {
            var url = $(this).data('url')
            var pid = $(this).data('pid')
            $.ajax({
                method: 'get',
                url: url,
                beforeSend: function () {
                    $('#cart_modal_box').empty();
                    $('#cart_modal_box').append('<div class="d-flex height_100_percent"><div class="spin max_size"></div></div>');
                },
                data: {
                    pid: pid
                },
                success: function (response) {
                    $('#cart_modal_box').html(response.renderTemplate);
                }
            });
        });
    },
    triggerAddToCartModal: function () {
        $('body').on('click', '.js-cart_modal_btn', function () {
            var inputImages = $('input.input-images');
            inputImages.each(function(i, elm) {
                var image = $(elm);
                var colorId = image.data('id');
                var imageURL = image.val();
                $('img[data-color="' + colorId + '"]').attr('src', imageURL);
            });
        });
    },
    searchInventory: function () {
        $("#selectItem").on('change', function () {
            var url = $(this).data("action");
            var img = $(this).find(':selected').data('img');
            if (url) {
                $.ajax({
                    url: url,
                    method: "POST",
                    data: {productId: $(this).val()},
                    success: function (data) {
                        if (data.success) {
                            $('#store-detail-container').html(data.template);
                            $('.img-store-detail').attr('src', img);
                        }
                    },
                    error: function () {
                    },
                });
            }
        });
    }
};

$(function () {
    $(".tab__nav ul li span").click(function (e) {
        e.preventDefault();
        var target = $(this).data("target");
        $(".tab__nav ul li span").removeClass("is-active");
        $(this).addClass("is-active");
        $(".tab-item").removeClass("is-active");
        $(target).addClass("is-active");
        var heightContent = $('.side__tab .tab-item.is-active').find('.tab__body').outerHeight();
        if (heightContent < 222) {
            $('.side__tab .tab-item.is-active').find('.grad-btn').css('display', 'none');
            $('.side__tab .tab-item.is-active').find('.tab__body').css('max-height', 'none');
        }
    });
});

$(function () {
    var width = $(window).width();
    if(width < 769){
        $('.vs-placeholder-smart-table.u-desktop').remove();
    }
});

$(document).ready(function () {
    $('#selectItem').change();
});


jQuery(function ($) { // この中であればWordpressでも「$」が使用可能になる

    // // ボタンの表示設定
    $('.store_modal_inner').on('scroll', function () {
        if ($(this).scrollTop() > 0) {
            // 指定px以上のスクロールでボタンを表示
            $('.to-top_2').fadeIn();
        } else {
            // 画面が指定pxより上ならボタンを非表示
            $('.to-top_2').fadeOut();
        }
    });
    $('.size_modal_inner').on('scroll', function () {
        if ($(this).scrollTop() > 50) {
            // 指定px以上のスクロールでボタンを表示
            $('.to-top_2.size_to_top').fadeIn();
        } else {
            // 画面が指定pxより上ならボタンを非表示
            $('.to-top_2.size_to_top').fadeOut();
        }
    });


    $(document).on("click", ".to-top_2", function () {
        $('.store_modal_inner').animate({
            scrollTop: 0
        }, 300, 'swing');
        return false;
    });
    $(document).on("click", ".to-top_2.size_to_top", function () {
        $('.size_modal_inner').animate({
            scrollTop: 0
        }, 300, 'swing');
        return false;
    });


    if ($('.page_product_detail .list_tag').length > 0 && sessionStorage.getItem('parameterPLP')) {
        $(".page_product_detail .list_tag .hashtag").each(function() {
            var href = $(this).attr('href') + '&' + sessionStorage.getItem('parameterPLP');
            $(this).attr('href', href);
        });
        sessionStorage.removeItem('parameterPLP');
    }
      
});

//シェアボタン
var userAgent = navigator.userAgent;
if (/Android/i.test(userAgent) && /MGRe/i.test(userAgent)) {
    $('.urlShare_button').css('display', 'none');
}
const shareButton = document.getElementById('webShareApi_buttom');
if (shareButton) {
    shareButton.addEventListener('click', async () => {
        try {
            await navigator.share(
                {
                    url: location.href
                });
        } catch (error) {
            console.error
        }
    });     
}

$(document).on('click', '.annotation-button', function(event) {
    event.stopPropagation();
    var $modalWrap = $('.annotation-modal');
    $modalWrap.toggleClass('d-none');
});

$(document).on('click', function(event) {
    var $modalContainer = $('.annotation-message');
    
    if (!$modalContainer.is(event.target) && $modalContainer.has(event.target).length === 0) {
        var $modalWrap = $('.annotation-modal');
        $modalWrap.addClass('d-none');
    }
});

$(document).on('click', '.annotation-message', function(event) {
    event.stopPropagation();
});
